import { memo, useMemo } from 'react';
import TagCategory from './TagCategory.styles';
import { TagsFilterProps } from './types';
import { groupSelectedTags } from './utils';

function TagsFilter(props: TagsFilterProps) {
  const { categories, onTagFilterChange, searchText, selectedTags } = props;

  const selectedMap = useMemo(() => {
    return groupSelectedTags(selectedTags);
  }, [selectedTags]);

  const categoriesMapped = categories.map(category => {
    return (
      <TagCategory
        searchText={searchText}
        key={category.id}
        category={category}
        selectedMap={selectedMap}
        onTagFilterChange={onTagFilterChange}
      />
    );
  });
  return <div>{categoriesMapped}</div>;
}
export default memo(TagsFilter);
